import { setAnalytics, isDuplicatePageError } from '../../../thd-analytics-utils';
import {
  MY_ACCOUNT,
  MY_ACCOUNT_SECURITY,
  MY_ACCOUNT_SECURITY_PAGE_TYPE,
  SECURITY_AND_SIGN_IN
} from '../../../constants';

export function security() {
  // analytics.setPageView() (src/utils/analytics.ts)
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('security.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: MY_ACCOUNT_SECURITY,
        pageType: MY_ACCOUNT_SECURITY_PAGE_TYPE
      },
      category: {
        primaryCategory: MY_ACCOUNT,
        subCategory1: MY_ACCOUNT,
        subCategory2: MY_ACCOUNT_SECURITY
      }
    };

    setAnalytics(digitalData);
  });

  // analytics.addPageData(pageData) (src/components/SignInSecurity/AccountProvider.tsx)
  // Trigger: API error on initial profile fetch
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('security.page-error', ({ output }) => {
    const {
      type = 'error',
      displayType = 'page',
      pageSection = SECURITY_AND_SIGN_IN,
      message = '',
      code = ''
    } = output || {};

    const pageError = {
      type,
      displayType,
      pageSection,
      message,
      code
    };

    digitalData.page = digitalData.page || {};
    digitalData.page.error = digitalData.page.error || [];
    if (!isDuplicatePageError(digitalData, pageError)) {
      digitalData.page.error.push(pageError);
    }
  });
}
